import { useEffect } from "react";
import { ensureElementVisible } from "../../../utilities/scrollHelpers";

// Auto-scroll selected item into view
export const useEnsureSelectedVisible = (open, enabled, groups, listRootRef) => {
    useEffect(() => {
        if (!open || !enabled) return;
        const ensureSelected = () => {
            const root = listRootRef.current;
            if (!root) return;
            ensureElementVisible(root, ".flight-menu-item--selected", {
                smooth: true,
                padding: 8,
                fallbackDelayMs: 60,
                centerFallback: true,
            });
        };
        requestAnimationFrame(() => {
            ensureSelected();
            setTimeout(ensureSelected, 1500);
        });
    }, [open, enabled, groups, listRootRef]);
};

export default useEnsureSelectedVisible;


